import { getCookieConsentService } from '../privacy/cookie/CookieConsentService';
import { LEGACY_CONSENT_KEY } from '../privacy/constants';

export type CookieConsent = 'essential' | 'analytics' | null;

/** @deprecated getCookieConsentService().getConsent() kullanın */
export function getCookieConsent(): CookieConsent {
  const record = getCookieConsentService().getConsent();
  if (!record) return null;
  return record.preferences.analytics ? 'analytics' : 'essential';
}

/** @deprecated getCookieConsentService().savePreferences() kullanın */
export function setCookieConsent(consent: Exclude<CookieConsent, null>): void {
  const service = getCookieConsentService();
  if (consent === 'analytics') {
    service.acceptAll();
  } else {
    service.acceptEssentialOnly();
  }
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(LEGACY_CONSENT_KEY, consent);
  }
}

let analyticsLoaded = false;
let runtimeMeasurementId: string | undefined;

export function setAnalyticsMeasurementId(id: string): void {
  runtimeMeasurementId = id.trim() || undefined;
}

export function initAnalytics(): void {
  const measurementId = runtimeMeasurementId || import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!measurementId || analyticsLoaded || typeof window === 'undefined') return;
  if (!getCookieConsentService().isCategoryEnabled('analytics')) return;

  analyticsLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.dataset.luminaryAnalytics = 'true';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId, { anonymize_ip: true });
}

export function revokeAnalytics(): void {
  analyticsLoaded = false;
  if (typeof document === 'undefined') return;

  document.querySelectorAll('script[data-luminary-analytics]').forEach((el) => el.remove());
  document.querySelectorAll(`script[src*="googletagmanager.com/gtag"]`).forEach((el) => el.remove());

  delete window.gtag;
  window.dataLayer = [];
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}
